{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -77.84050465334256,
              7.196629099371918
            ],
            [
              -77.13007542666841,
              7.933199229888814
            ],
            [
              -77.3825217720186,
              8.67617834717737
            ],
            [
              -78.37352213047464,
              9.816572461027576
            ],
            [
              -82.53348406902234,
              9.571760054669014
            ],
            [
              -82.88872341450116,
              9.62948221111543
            ],
            [
              -83.05164482424911,
              8.328560417188314
            ],
            [
              -82.88414795819546,
              8.016642476274114
            ],
            [
              -82.08099217720113,
              6.7024944297843945
            ],
            [
              -77.84050465334256,
              7.196629099371918
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}